import { render, staticRenderFns } from "./TaskGroup.vue?vue&type=template&id=540b44d2&scoped=true&"
import script from "./TaskGroup.vue?vue&type=script&lang=js&"
export * from "./TaskGroup.vue?vue&type=script&lang=js&"
import style0 from "./TaskGroup.vue?vue&type=style&index=0&id=540b44d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b44d2",
  null
  
)

export default component.exports